import React, { useState } from "react";
import Whiteboard from "./pages/map/Whiteboard.js";
import R6sWhiteboard from "./pages/map/R6sWhiteboard.js";
import Toolbar from "./toolbars/Toolbar.js";
import R6UtilityToolbar from "./toolbars/R6UtilityToolbar.js";
import GameHome from "./pages/game-home/GameHome.js";
import R6GameHome from "./pages/game-home/R6GameHome.js";
import GameSelect from "./pages/game-select/GameSelect.js";

function getInitialView() {
  const hostname = window.location.hostname.toLowerCase().replace(/^www\./, "");
  return hostname === "r6tacmaps.gg" ? "home" : "game-select";
}

function App() {
  const [view, setView] = useState(getInitialView);
  const [activeTool, setActiveTool] = useState("move");
  const [drawingColor, setDrawingColor] = useState("#ff0000");
  const [selectedShape, setSelectedShape] = useState(null); // null | 'square' | 'circle' | 'line'
  const [clearDrawings, setClearDrawings] = useState(false);
  const [selectedMaps, setSelectedMaps] = useState({});
  const [calloutsVisible, setCalloutsVisible] = useState(false);
  const [camsVisible, setCamsVisible] = useState(true);
  const [backgroundUtility, setBackgroundUtility] = useState(() => ({
    id: "background",
    label: "Background",
    imageSrc: selectedMaps && selectedMaps.map
      ? `/maps/R6S/${selectedMaps.map.basemap}/${selectedMaps.map.id}.png`
      : null
  }));
  const undoRef = React.useRef(null);
  const redoRef = React.useRef(null);
  const exportRef = React.useRef(null);

  // playback state and controls
  const [playCommand, setPlayCommand] = useState({ type: null, ts: 0 });
  const [isPlaying, setIsPlaying] = useState(false);
  const [objectiveCommand, setObjectiveCommand] = useState(0);

  // current game (used to enable game-specific UI like R6 popouts)
  const [game, setGame] = useState("r6s");
  // current selection from the utility toolbar when a text-type button
  // is active.  Stored as the full button object or `null` when nothing
  // is selected.  The whiteboard will show/hide an associated image
  // based on this value.
  const [textUtilitySelection, setTextUtilitySelection] = useState(null);

  // hold the full map object returned by R6sWhiteboard via onMapChange
  const [currentMapObj, setCurrentMapObj] = useState(null);
  const onAction = (action) => {
    if (action === "clear") setClearDrawings((c) => !c);
    if (action === "home") {
      setCalloutsVisible(false);
      setView("home");
    }
    if (action === "undo") undoRef.current && undoRef.current();
    if (action === "redo") redoRef.current && redoRef.current();
    if (action === "play") {
      if (isPlaying) {
        setPlayCommand({ type: "pause", ts: Date.now() });
        setIsPlaying(false);
      } else {
        setPlayCommand({ type: "play", ts: Date.now() });
        setIsPlaying(true);
      }
    }
    if (action === "export") {
      exportRef.current && exportRef.current();
    }
    if (action === "objective") {
      setObjectiveCommand((command) => command + 1);
    }
    if (action === "callouts") {
      setCalloutsVisible((visible) => !visible);
    }
  };

  // const onSelectTool = (tool) => {
  //   setActiveTool(tool);
  // };

  const handlePlay = (maps) => {
    setCalloutsVisible(false);
    setSelectedMaps(maps);
    setView("whiteboard");
  };

  const handleR6MapSelect = (map) => {
    setCalloutsVisible(false);
    setSelectedMaps({ map });
    setView("whiteboard");
  };

  const handleGameSelect = (selectedGame) => {
    setGame(selectedGame);
    setView("home");
  };

  return (
    <div className="App app-layout" style={{ width: "100%", height: "100%", overflow: "hidden", display: "flex"}}>
      {view === "game-select" ? (
        <GameSelect onGameSelect={handleGameSelect} />
      ) : view === "home" ? (
        game === "r6s" ? (
          <R6GameHome
            game={game}
            onMapSelect={handleR6MapSelect}
            onBackToGameSelect={() => setView("game-select")}
          />
        ) : (
          <GameHome
            onPlay={handlePlay}
            game={game}
            onBackToGameSelect={() => setView("game-select")}
          />
        )
      ) : game === "r6s" ? (
        <>
          <Toolbar activeTool={activeTool} onSelectTool={setActiveTool} onAction={onAction} isPlaying={isPlaying} selectedShape={selectedShape} onSelectShape={setSelectedShape} drawingColor={drawingColor} onDrawingColorChange={setDrawingColor} />
          <div className="board-layout">
            <R6sWhiteboard 
              activeTool={activeTool}
              selectedShape={selectedShape}
              clearDrawings={clearDrawings}
              registerUndo={(fn) => (undoRef.current = fn)}
              registerRedo={(fn) => (redoRef.current = fn)}
              registerExport={(fn) => (exportRef.current = fn)}
              playCommand={playCommand}
              onPlaybackFinished={() => setIsPlaying(false)}
              textUtility={textUtilitySelection}
              backgroundUtility={backgroundUtility}
              game={game}
              drawingColor={drawingColor}
              selectedMap={selectedMaps.map}
              onMapChange={setCurrentMapObj}
              calloutsVisible={calloutsVisible}
              camsVisible={camsVisible}
            />
            <R6UtilityToolbar onTextToggleSelect={setTextUtilitySelection} onBackgroundToggleSelect={setBackgroundUtility} selectedMap={currentMapObj} onCamsToggle={setCamsVisible} />
          </div>
          
        </>
      ) : (
        <>
          <Toolbar activeTool={activeTool} onSelectTool={setActiveTool} onAction={onAction} isPlaying={isPlaying} selectedShape={selectedShape} onSelectShape={setSelectedShape} drawingColor={drawingColor} onDrawingColorChange={setDrawingColor} />
          <Whiteboard 
            activeTool={activeTool}
            selectedShape={selectedShape}
            clearDrawings={clearDrawings}
            registerUndo={(fn) => (undoRef.current = fn)}
            registerRedo={(fn) => (redoRef.current = fn)}
            registerExport={(fn) => (exportRef.current = fn)}
            playCommand={playCommand}
            onPlaybackFinished={() => setIsPlaying(false)}
            game={game}
            selectedMap={selectedMaps.map}
            selectedMapLabel={selectedMaps.mapLabel}
            selectedMode={selectedMaps.mode}
            objectiveCommand={objectiveCommand}
            calloutsVisible={calloutsVisible}
            drawingColor={drawingColor}
          />
        </>
      )}
    </div>
  );
}

export default App;
